import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { extension as getExtension } from "mime-types";

import {
  Container,
  TextContainer,
  Heading,
  SubHeading,
  IconContainer,
  BackIcon,
  MessageTypeIcon,
  HeadingBox,
  RotateIcon,
  CloseIcon,
} from "./HeaderStyles";
import { getFormattedTime } from "util/timeUtility";
import Icon from "konnekt/Icon";
import { showNotification, getFileType } from "util/utility";
import { fetchApi } from "util/apiCaller";
import { getHTMLDecodedText } from "util/chatUtil";

const Header = ({ data, onRotateClick, handleClose }) => {
  const themeContext = useContext(ThemeContext);

  const handleDownloadClick = async () => {
    // todo - check if analytics download logic and this can be combined
    const response = await fetchApi("media_download", "POST", {
      media_url: getHTMLDecodedText(data.src),
    });

    if (response.status !== 200) {
      showNotification("Unable to download the media file");
      return;
    }

    const contentType = response.headers.get("Content-Type");

    const blob = await response.blob();
    const blobURL = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.style = "display: none";
    a.setAttribute("target", "_blank");

    if (contentType === "application/octet-stream") {
      a.href = getHTMLDecodedText(data.src);
    } else {
      a.href = blobURL;
      a.download = `download.${getExtension(contentType)}`;
    }

    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      a.remove();
    }, 2000);
  };

  const renderRotateBtn = () => {
    if (getFileType(data?.src) === "Image" || data?.contentType === "Image") {
      return (
        <RotateIcon
          iconName="rotateRight"
          height="20px"
          width="20px"
          color="#000000"
          mr="18px"
          onClick={onRotateClick}
          data-tip="Rotate"
          data-for="rotate"
        />
      );
    }

    return null;
  };

  const renderDownloadBtn = () => {
    if (
      !(
        getFileType(data?.src) === "Video" ||
        data?.contentType === "Video" ||
        getFileType(data?.src) === "Audio" ||
        data?.contentType === "Audio"
      )
    ) {
      const iconDimension =
        window.screen.width > themeContext.breakpoints.mobileL
          ? "20px"
          : "24px";
      return (
        <Icon
          onClick={handleDownloadClick}
          iconName="download"
          height={iconDimension}
          width={iconDimension}
          color="#000000"
          data-tip="Download"
          data-for="download"
        />
      );
    }

    return null;
  };

  if (!data) {
    return null;
  }

  return (
    <Container>
      <BackIcon
        iconName="close"
        height="16px"
        width="16px"
        color="#000000"
        onClick={handleClose}
        data-tip="Close"
        data-for="closeIcon"
      />

      <TextContainer>
        <HeadingBox>
          <MessageTypeIcon
            iconName={data?.messageType === "Sent" ? "outgoing" : "incoming"}
            height="16px"
            width="16px"
            color="#000000"
          />
          <Heading>{data?.messageType}</Heading>
        </HeadingBox>
        <SubHeading>
          {getFormattedTime(data.date, "MMM DD, hh:mm a")}
        </SubHeading>
      </TextContainer>

      <IconContainer>
        {renderRotateBtn()}
        {renderDownloadBtn()}

        <CloseIcon
          onClick={handleClose}
          iconName="close"
          height="18px"
          width="18px"
          data-tip="Close"
          data-for="closeIcon"
        />
      </IconContainer>
    </Container>
  );
};

export default Header;
